<span class="iu-input-chips-ui" [style.backgroundColor]="backgroundColorCss" [style.display]="displayCss">
  @if (this.isLabelDisplay) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      {{ label }}
    </label>
  }
  <iu-prime-chips
    #input
    [addOnBlur]="addOnBlur"
    [addOnEnter]="addOnEnter"
    [addOnSpace]="addOnSpace"
    [addOnTab]="addOnTab"
    [allowDuplicate]="false"
    [columnName]="columnName"
    [editOnBackspace]="editOnBackspace"
    [inContainer]="inContainer"
    [inputId]="uuid"
    [inputStyle]="inputStyle"
    [inputType]="inputType"
    [matchPattern]="matchPattern"
    [(ngModel)]="fieldValue"
    (onAdd)="onValueChange($event.originalEvent)"
    (onRemove)="onValueChange($event.originalEvent)" />
</span>
